import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { initialState } from '@/modules/allies/allies/store/bankAccountSlice/initialState.ts'

const bankAccountSlice = createSlice({
  name: 'bankAccount',
  initialState,
  reducers: {
    setIsCreateBankAccountModalOpen: (
      state,
      action: PayloadAction<boolean>
    ) => {
      state.isCreateBankAccountModalOpen = action.payload
    },
    setIsEditBankAccountModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isEditBankAccountModalOpen = action.payload
    },
    setSelectedBankAccountId: (state, action: PayloadAction<string | null>) => {
      state.selectedBankAccountId = action.payload
    },
    setSelectedCommercialAllyId: (
      state,
      action: PayloadAction<string | null>
    ) => {
      state.selectedCommercialAllyId = action.payload
    },
    setIsSetDefaultBankAccountModalOpen: (
      state,
      action: PayloadAction<boolean>
    ) => {
      state.isSetDefaultBankAccountModalOpen = action.payload
    },
    reset: () => initialState
  }
})

export const bankAccountActions = bankAccountSlice.actions
export const { reducer: bankAccountReducer } = bankAccountSlice
